
const messages = {
   en: {
      auth: {
         passwordRequirements: 'At least 8 characters, including one number and one special character',
         passwordMinLength: 'Password must be at least 8 characters',
         passwordMustIncludeNumber: 'Password must include at least one number',
         passwordMustIncludeSpecial: 'Password must include at least one special character',
         passwordValidation: 'Password does not meet the security requirements',
      },
      base: {
         home: 'Home',
         about: 'About',
         welcome: 'Welcome',
         enter: 'Enter',
         subtitleCardStock: 'Product management',
         subtitleCardVentas: 'Sales management',
         subtitleCardArchivos: 'File management',
         subtitleDashboards: 'Dashboard management',
         subtitleConfiguracion: 'Configuration management'
      },
      common: {
         name: 'Name',
         lastname: 'Lastname',
         required: 'Required',
         search: 'Search',
         cancel: 'Cancel',
         loading: 'Loading',
         processing: 'Processing',
         noData: 'No data',
         add: 'Add',
         submit: 'Submit',
         save: 'Save',
         start: 'Start',
         create: 'Create',
         update: 'Update',
         delete: 'Delete',
         created: 'Created',
         updated: 'Updated',
         deleted: 'Deleted',
         show: 'show',
         close: 'Close',
         send: 'Send',
         confirm: 'Confirm',
         next: 'Next',
         previous: 'Previous',
         actions: 'Actions',
         areYouSureDeleteRecord: 'Are you sure you want to blur this record?',
         networkError: 'Network error. The server does not respond.',
         export: 'Export',
         import: 'Import',
         title: 'Title',
         subtitle: 'Subtitle',
         true: 'True',
         false: 'False',
         consult: 'Consult',
         detail: 'Detail | Details',
         filter: 'Filter | Filters',
         clearFilters: 'Clear filters',
         applyFilters: 'Apply filters',
         active: 'Active',
         inactive: 'Inactive',
         precioManualTooltip: 'Price was modified manually',
         operation: {
            success: 'Operation success',
            fail: 'Operation fail'
         }
      }

   },
   es: {
      auth: {
         passwordRequirements: 'Mínimo 8 caracteres, incluyendo un número y un carácter especial',
         passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
         passwordMustIncludeNumber: 'La contraseña debe incluir al menos un número',
         passwordMustIncludeSpecial: 'La contraseña debe incluir al menos un carácter especial',
         passwordValidation: 'La contraseña no cumple los requisitos de seguridad',
      },
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: 'Bienvenido',
         enter: 'Ingresar',
         subtitleCardStock: 'Gestión de productos',
         subtitleCardVentas: 'Ventas',
         subtitleCardArchivos: 'Gestión de archivos',
         subtitleDashboards: 'Visualización de dashboards',
         subtitleConfiguracion: 'Gestión de Configuración'
      },
      common: {
         name: 'Nombre',
         lastname: 'Apellido',
         required: 'Requerido',
         search: 'Buscar',
         cancel: 'Cancelar',
         loading: 'Cargando',
         processing: 'Procesando',
         noData: 'Sin datos',
         add: 'Agregar',
         submit: 'Enviar',
         save: 'Guardar',
         create: 'Crear',
         start: 'Comenzar',
         update: 'Actualizar',
         delete: 'Borrar',
         created: 'Creado',
         updated: 'Actualizado',
         deleted: 'Eliminado',
         show: 'Mostrar',
         close: 'Cerrar',
         send: 'Enviar',
         confirm: 'Confirmar',
         next: 'Siguiente',
         previous: 'Anterior',
         actions: 'Acciones',
         areYouSureDeleteRecord: '¿Está seguro que desea borrar este registro?',
         networkError: 'Error de red. El servidor no responde.',
         export: 'Exportar',
         import: 'Importar',
         title: 'Titulo',
         subtitle: 'Subtitulo',
         true: 'Verdadero',
         false: 'Falso',
         consult: 'Consultar',
         detail: 'Detalle | Detalles',
         filter: 'Filtro | Filtros',
         clearFilters: 'Limpiar filtros',
         applyFilters: 'Aplicar filtros',
         active: 'Activo',
         inactive: 'Inactivo',
         precioManualTooltip: 'Precio modificado manualmente',
         operation: {
            success: 'Operación exitosa',
            fail: 'Operación fallida'
         }
      }
   },
   pt: {
      auth: {
         passwordRequirements: 'Mínimo 8 caracteres, incluindo um número e um caractere especial',
         passwordMinLength: 'A senha deve ter pelo menos 8 caracteres',
         passwordMustIncludeNumber: 'A senha deve incluir pelo menos um número',
         passwordMustIncludeSpecial: 'A senha deve incluir pelo menos um caractere especial',
         passwordValidation: 'A senha não atende aos requisitos de segurança',
      },
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: 'Bem-vindo',
         enter: 'Entrar',
         subtitleCardStock: 'Gestão productos',
         subtitleCardVentas: 'Gestão ventas',
         subtitleCardArchivos: 'Gestião archivos',
         subtitleDashboards: 'Visualização de dashboards',
         subtitleConfiguracion: 'Gestão configuracion'
      },
      common: {
         name: 'Nome',
         lastname: 'Último nome',
         required: 'Requeridos',
         search: 'Procurar',
         cancel: 'Cancelar',
         loading: 'Carregando',
         processing: 'Em processamento',
         noData: 'Não há dados',
         add: 'Adicionar',
         submit: 'Submit',
         save: 'Salve',
         start: 'Começar',
         create: 'Criar',
         update: 'Atualizar',
         delete: 'Excluir',
         created: 'Criado',
         updated: 'Atualizado',
         deleted: 'Excluído',
         show: 'Mostrar',
         close: 'Fechar',
         send: 'Enviar',
         confirm: 'Confirme',
         next: 'Próximo',
         previous: 'Anterior',
         actions: 'Ações',
         areYouSureDeleteRecord: 'Tem certeza de que deseja excluir este registro?',
         networkError: 'Erro de rede. O servidor não responde.',
         export: 'Exportar',
         import: 'Importar',
         title: 'Título',
         subtitle: 'Subtítulo',
         true: 'Verdade',
         false: 'Falso',
         consult: 'Consultar',
         detail: 'Detalhe | Detalhes',
         filter: 'Filtro | Filtros',
         clearFilters: 'Limpar filtros',
         applyFilters: 'Aplicar filtros',
         active: 'Ativo',
         inactive: 'Inativo',
         precioManualTooltip: 'Preço modificado manualmente',
         operation: {
            success: 'Operação bem sucedida',
            fail: 'Operação falhou'
         }
      }
   }
}

export default messages
